// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"74b5df1b3b8a1b58","9160":"48083b10b0fbd717"}[chunkId] + ".css";
};